import { Helmet } from 'react-helmet-async';
import { Button, Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { distributePrizes, getMatchResults, verifyMatchResult } from '../services/Common/matchResult.service';

export default function MatchResultsPage() {
    const { id } = useParams();
    const [results, setResults] = useState([]);

    const load = () => getMatchResults(id).then(setResults).catch(() => toast('Failed to load match results', { type: 'error' }));
    useEffect(load, [id]);

    const review = async (resultId, status) => {
        try {
            await verifyMatchResult(resultId, status);
            toast(`Result ${status}`, { type: 'success' });
            load();
        } catch (_) {
            toast('Failed to review result', { type: 'error' });
        }
    };

    const payPrizes = async () => {
        try {
            await distributePrizes(id);
            toast('Reward requests created successfully', { type: 'success' });
            load();
        } catch (_) {
            toast('Reward requests could not be created', { type: 'error' });
        }
    };

    return (
        <>
            <Helmet><title>Match Results | Trooper</title></Helmet>
            <Container>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                    <Typography variant="h4">Match Results</Typography>
                    <Button variant="contained" onClick={payPrizes}>Create Reward Requests</Button>
                </Stack>
                <Grid container spacing={2}>
                    {results.map((result) => (
                        <Grid item xs={12} md={6} key={result._id}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6">{result.team?.team_name || 'Team'}</Typography>
                                    <Typography variant="body2">Submitted by: {result.submittedBy?.name || 'User'}</Typography>
                                    <Typography sx={{ mt: 1 }}>Kills: {result.kills} | Position: {result.position}</Typography>
                                    <Typography>Status: {result.status}</Typography>
                                    <img src={result.screenshot} alt="Match proof" style={{ width: '100%', maxHeight: 260, objectFit: 'contain', marginTop: 12 }} />
                                    {result.status === 'pending' && (
                                        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                                            <Button variant="contained" onClick={() => review(result._id, 'approved')}>Approve</Button>
                                            <Button color="error" variant="outlined" onClick={() => review(result._id, 'rejected')}>Reject</Button>
                                        </Stack>
                                    )}
                                    {result.status === 'approved' && <Typography sx={{ mt: 1 }}>Points: {result.totalPoints}</Typography>}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </>
    );
}
